module.exports = __webpack_public_path__ + "static/img/Great_Work.2df94bd9.png";